var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReminderWhiteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 26,
    viewBox: "0 0 30 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.3333 14.5232V12.5977C25.3333 8.50652 22.2393 5.039 18 3.90645V2.63672C18 1.18283 16.6542 0 15 0C13.3458 0 12 1.18283 12 2.63672V3.90645C7.76072 5.039 4.66673 8.50646 4.66673 12.5977V14.5232C4.66673 18.1168 3.1082 21.5244 0.278277 24.1182C0.00094458 24.3724 -0.0769886 24.7475 0.0802109 25.0714C0.23741 25.3953 0.599409 25.6055 1.00007 25.6055H29C29.4007 25.6055 29.7626 25.3953 29.9198 25.0714C30.077 24.7475 29.9991 24.3724 29.7218 24.1182C26.8919 21.5244 25.3333 18.1168 25.3333 14.5232ZM16 3.55828C15.6709 3.53039 15.3374 3.51562 15 3.51562C14.6627 3.51562 14.3292 3.53039 14 3.55828V2.63672C14 2.15209 14.4486 1.75781 15 1.75781C15.5514 1.75781 16 2.15209 16 2.63672V3.55828Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReminderWhiteIcon);
export default __webpack_public_path__ + "static/media/reminderWhiteIcon.c93caa8cc4891aca1fd368f0d7c3d43b.svg";
export { ForwardRef as ReactComponent };